<template>
  <b-card class="question-metric">
    <header>
      <small>{{
        `${question.uniqueAnswers} ${labels.answers} - ${question.skipped} ${labels.ignored}`
      }}</small>
      <h3>{{ `${number}. ${question.text}` }}</h3>
      <small v-if="!(question.uniqueAnswers + question.skipped)">
        <i class="material-icons">
          info
        </i>
        {{ labels.insufficientData | parse() }}
      </small>
    </header>

    <section>
      <QuestionMetricSlideNumber
        v-if="question.type === 'slide-number'"
        :question="question"
        :isEmpty="!(question.uniqueAnswers + question.skipped)"
      >
      </QuestionMetricSlideNumber>

      <QuestionMetricRadioString
        v-if="question.type === 'radio-string'"
        :question="question"
        :isEmpty="!(question.uniqueAnswers + question.skipped)"
      >
      </QuestionMetricRadioString>

      <QuestionMetricParagraph
        v-if="question.type === 'paragraph'"
        :question="question"
        :isEmpty="!(question.uniqueAnswers + question.skipped)"
      >
      </QuestionMetricParagraph>
    </section>

    <footer v-if="question.feedback.text">
      <QuestionMetricComment :feedback="question.feedback">
      </QuestionMetricComment>
    </footer>
  </b-card>
</template>

<script>
import QuestionMetricSlideNumber from './QuestionMetricSlideNumber.vue'
import QuestionMetricRadioString from './QuestionMetricRadioString.vue'
import QuestionMetricParagraph from './QuestionMetricParagraph.vue'
import QuestionMetricComment from './QuestionMetricComment.vue'
import { mapGetters } from 'vuex'

const props = {
  question: {
    type: Object,
    required: true,
  },
  number: {
    type: Number,
    required: false,
  },
}

export default {
  props,
  components: {
    QuestionMetricSlideNumber,
    QuestionMetricRadioString,
    QuestionMetricParagraph,
    QuestionMetricComment,
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.page.home.customPoll.report.questionMetric
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

.question-metric {
  .card-body {
    padding: 0;

    header {
      padding: 1.25rem 1.25rem 0.25rem;

      small {
        color: map-get($theme-colors, 'gray03');
        font-size: 14px;
      }

      h3 {
        color: map-get($theme-colors, 'septenary');
        font-size: 30px;
        font-weight: 500;
      }
    }
  }
}
</style>
